import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricConfigurationVault from './metric-configuration-vault-model'
import {
  delete_metricConfigurationVault,
  load_metricConfigurationVaults,
  store_metricConfigurationVault,
} from './metricConfigurationVault-service'

export const LoadMetricConfigurationVaultsAsync = createAsyncThunk<any, any>(
  'composer/load/metricConfigurationVault',
  async (params: { uid: string }) => {
    return await load_metricConfigurationVaults(params)
  },
)

export const CreateMetricConfigurationVaultAsync = createAsyncThunk<any, any>(
  'composer/create/metricConfigurationVault',
  async (params: MetricConfigurationVault) => {
    return await store_metricConfigurationVault(params)
  },
)

export const DeleteMetricConfigurationVaultAsync = createAsyncThunk<any, any>(
  'composer/delete/metricConfigurationVault',
  async (params) => {
    return await delete_metricConfigurationVault(params)
  },
)
